import React from 'react';

class AmazonLink extends React.Component {

    constructor (props) {
        super(props);
    }

    render () { 
        return (
            <a className="amazon-link" href={ 'https://www.amazon.com/gp/search?ie=UTF8&keywords='+encodeURIComponent(this.props.artist)+'-'+encodeURIComponent(this.props.title)+'&tag=muzbox-20&index=digital-music-track&linkCode=ur2&camp=1789&creative=9325' } target="_blank" id="amazon-link">
                <div className="floyds-red-text amazon-text">BUY ON AMAZON</div>
                <img src="http://g-ecx.images-amazon.com/images/G/01/lwa/btnLWA_gold_92x92._CB372074599_.png" alt="Buy on Amazon" />
            </a>
        );
    }
}
 
export default AmazonLink;


// WEBPACK FOOTER //
// ./src/AmazonLink.js